import { api } from "./api";

const defaultParams = {
  initForm: true,
};

const defaultBuildParams = {};

export default class reportHandler {
  constructor(uuid) {
    this.uuid = uuid;
  }

  /** get report and extract extras */
  init = async (initParams = {}) => {
    //assing params
    const pararms = Object.assign(defaultParams, initParams);

    //get report
    this.report = (await api.q("/report/get", { id: this.uuid })) || {};

    if (this.report.id) {
      //append build form if needed
      if (pararms.initForm) {
        await this.buildForm();
      }
      return this.report;
    }
    return false;
  };

  buildForm = async (params = {}) => {
    this.form = await api.q("/report/form/build", {
      id: this.uuid,
      params,
    });
  };

  /** preform report build */
  build = async (form = {}, buildParams = {}) => {
    const saveData = { ...form };
    const { fields = [] } = this.form;

    //assing params
    const params = Object.assign(defaultBuildParams, buildParams);

    const fileFields = fields
      .filter((f) => f.type === "file")
      .map((f) => f.key);

    //if form contains file fields
    if (fileFields.length > 0 && !params.skipFiles) {
      console.log("files start", fileFields, saveData);

      //create bunch of reader promises and mutate savedata
      let fileReaderPromises = {};
      fileFields.forEach((key) => {
        let newSaveDataValue = [];
        if (saveData[key]) {
          let filesArray = Array.from(saveData[key]) || [];
          filesArray.forEach((file, idx) => {
            console.log("add promise", file, idx);
            fileReaderPromises[`${key}~${idx}`] = api.toBase64(file);
            newSaveDataValue[idx] = {
              name: file.name,
              size: file.size,
              date: file.lastModifiedDate,
              text: file.name,
              data: "",
              path: "",
            };
          });
          saveData[key] = newSaveDataValue;
        }
      });

      //mutate savedata when all promises are done
      let fileRederResults = await Promise.allSettled(
        Object.values(fileReaderPromises)
      );
      fileRederResults.forEach(({ value }, idx) => {
        let key = Object.keys(fileReaderPromises)[idx].split("~");
        console.log(key, value);
        saveData[key[0]][key[1]].data = value.encoded;
        saveData[key[0]][key[1]].type = value.type;
      });

      console.log("files end", fileFields);
    }

    //preform build
    this.result =
      (await api.q("/report/build", { id: this.uuid, form: saveData })) || {};
    if (this.result.id) {
      await this.extract();
      return this.result;
    }
    return false;
  };

  extract = async (id = this.result.id) => {
    if (id) {
      this.result.files = await api.qa("/object/file", { id: id });
      if (this.result.files[0]) {
        if (this.result.files[0].type === "data:text/html;base64,") {
          let singleFile = await api.q("/object/file/get", {
            id: id,
            name: this.result.files[0].name,
          });
          if (singleFile.data) {
            let html = decodeURIComponent(
              atob(singleFile.data)
                .split("")
                .map(function (c) {
                  return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            );

            this.result.html = html;
          }
        }
      }
    }
  };
}
